export default {
  tipoDoc: 'Type of document',
  nroDoc: 'Number of document',
  nombres: 'Names',
  primerAp: 'First lastname',
  segundoAp: 'Second lastname',
  telefono: 'Mobile number',
  email: 'Email',
  nacionalidad: 'Nacionality',
  nro_apostilla: 'Apostille Number',
  cod_seguridad: 'Security code',
  codigo: 'Tracking code',
  day: 'Day',
  month: 'Month',
  year: 'Year',
  nombre_solicitante: 'Applicant name',
  precio: 'Price',
  estado: 'ESTADO (en)',
  fecha_expedicion: 'Date of apostille issuance',
  fecha_nacimiento: 'Birthday',
  fecha_solicitud: 'Fecha de solicitud (en)',
  docFactura: 'Número de documento',
  tipoFactura: 'Tipo de documento',
  nombreFactura: 'Nombre completo',
  det_tramite: 'Detalles de su trámite (ingles)',
  info_sol: 'DATOS DEL TITULAR DEL DOCUMENTO (en)',
  info_doc: 'DOCUMENTO(S) (en)',
  info_pago: 'DATOS DE PAGO (en)',
  info_finalizado: 'FINALIZADO (en)',
  info_cont: 'Ingrese sus datos personales y de contacto para recibir notificaciones sobre el estado de su trámite (ingles)',
  info_agregar: 'Agregue el/los documento(s) que necesita apostillar (en)',
  alert_doc: 'Todavía no tiene ningún documento agregado (en)',
  mis_doc: 'Mis documentos (en)',
  desc_doc: 'Descripción del/de los documento(s) (en)',
  select_doc: 'Seleccione un documento para apostillar (en)',
  doc: 'Documento (en)',
  docs: 'Documentos (en)',
  titulo_factura: 'Ingrese sus datos para la factura (en)',
  datos_pago: 'Verifique los datos de pago. La factura solo cubre el pago de la(s) apostilla(s) (en)',
  titular_factura: 'Señor(es) (en)',
  costo_doc: 'Costo de documento(s) (en)',
  costo_apostilla: 'Costo apostilla(s) (en)',
  confirmacion_solicitud: '¿Está seguro que quiere realizar su solicitud con estos datos? (en)',
  confirmar: 'Confirmar (en)',
  aceptar: 'Aceptar (en)',
  cancelar: 'Cancelar (en)',
  fin_solicitud: '¡Su solicitud se ha realizado correctamente! (en)',
  cod_seguimiento: 'Su código de seguimiento es (en):',
  guardar_codigo: 'Guarde el código (en)',
  seguimiento_codigo: ' de seguimiento para ver el estado de su solicitud ingresando (en)',
  aqui: 'aquí (en)',
  ingrese_codigo_seguimiento: 'Ingrese el código de seguimiento para ver el estado de su trámite. (en)',
  verificar_documento: 'Ingresa la información requerida para poder verificar que el documento se encuentre apostillado. (en)',
  datos_del_solicitante: 'Datos del solicitante (en)',
  pago_entidad: 'Pagado en la entidad (en)',
  pago_cancilleria: 'Pagado en Cancillería (en)',
  factura_tipo_documento: 'Tipo de documento',
  factura_titular_factura: 'Titular de factura',
  factura_nro_documento: 'Nro. de documento'
};



// WEBPACK FOOTER //
// ./src/lang/en/fields.js